export default __webpack_public_path__ + "static/media/api-open-edx.b712b48b.png";